import PropTypes from "prop-types";

import ActionButton from "../../formInputs/buttons/ActionButton";

import "../../../styles/GroupAccordionItem.scss";

const CommentEditor = ({
    id,
    label,
    placeholder,
    isVisible,
    onToggle,
    canEdit,
    isSaving,
    value,
    onChange,
    onSave,
    viewValue
}) => {
    const panelId = `${id}-panel`;
    return (
        <>
            <button
                className="toggle-subject-comment-btn"
                onClick={onToggle}
                aria-expanded={isVisible}
                aria-controls={panelId}
                aria-label={`${isVisible ? "Hide" : "View"} comment: ${label}`}
                type="button"
            >
                {isVisible ? "Hide " : "View "}Comment
            </button>

            {isVisible && (
                <div className="subject-comment-wrapper show" id={panelId} role="region" aria-label={label}>
                    <label htmlFor={id} className="visually-hidden">
                        {label}
                    </label>

                    {canEdit ? (
                        <textarea
                            id={id}
                            autoFocus
                            disabled={!canEdit || isSaving}
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            placeholder={placeholder}
                            className="subject-comment-textarea"
                        />
                    ) : (
                        <div className="comment-view">{viewValue ? viewValue : "No comment entered."}</div>
                    )}

                    {canEdit && (
                        <div style={{ textAlign: "right", margin: "8px 0px 16px 0px" }}>
                            <ActionButton
                                className="action-button-reg"
                                label={isSaving ? "Saving..." : "Save Comment"}
                                disable={isSaving}
                                onClick={onSave}
                            />
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

CommentEditor.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    canEdit: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    viewValue: PropTypes.string
};

CommentEditor.defaultProps = {
    viewValue: ""
};

export default CommentEditor;
